// Set by the sign-in form, read once by the layout: the welcome screen shows
// after a sign-in, not on every page load. Session storage can be unavailable
// (private browsing, blocked storage): the screen is then simply skipped.
const WELCOME_KEY = "opticercle.welcome";

export const markWelcomePending = () => {
  try {
    sessionStorage.setItem(WELCOME_KEY, "1");
  } catch {
    // no storage, no welcome screen
  }
};

export const isWelcomePending = () => {
  try {
    return sessionStorage.getItem(WELCOME_KEY) === "1";
  } catch {
    return false;
  }
};

export const clearWelcomePending = () => {
  try {
    sessionStorage.removeItem(WELCOME_KEY);
  } catch {
    // nothing to clear
  }
};
